import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    h2: "Éditeur du site",
    paragraphs: [
      "Le site est édité par ANTILLES CONSEIL STRATEGIE (ACS Corporate), EURL — entreprise unipersonnelle à responsabilité limitée — au capital de 100,00 €, immatriculée au Registre du Commerce et des Sociétés de Pointe-à-Pitre sous le numéro SIRET 102 681 012 00013.",
      "Siège social : 8 Allée des Bas de Grippiere, 97170 Petit-Bourg. Contact : contact@acs-corporate.com.",
    ],
  },
  {
    h2: "Directeur de la publication (Lucile Reimonenq)",
    paragraphs: [
      "La directrice de la publication est Madame Lucile Reimonenq, Fondatrice d'ACS Corporate.",
    ],
  },
  {
    h2: "Hébergement",
    paragraphs: [
      "L'hébergement du site est assuré par la plateforme Emergent (emergent.sh). La gestion du nom de domaine et la sécurisation de l'infrastructure réseau (SSL/CDN) sont assurées par Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, États-Unis.",
    ],
  },
  {
    h2: "Propriété intellectuelle",
    paragraphs: [
      "L'ensemble des contenus du site (textes, visuels, logo, charte graphique, méthodologies) est la propriété exclusive d'ACS Corporate.",
      "Toute reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation écrite préalable d'ACS Corporate est strictement interdite et constituerait une contrefaçon.",
    ],
  },
];

export default function MentionsLegales() {
  return <LegalPage title="Mentions Légales" sections={SECTIONS} />;
}
